import React from 'react';
import './styles.css';

const EmptyList = () => (
  <div className='emptyList-wrap'>
    <img src='/assets/images/13525-empty.gif' alt='empty' />
  </div>
);

export default EmptyList;
